export function ChartState({ children }: { children: string }) {
  return <div className="chart-state">{children}</div>;
}
